import { inject, Injectable } from '@angular/core'

import { UserProfile, UserProfileTiView, UserSnapshot } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { RealtimeClient } from '@ti/core/realtime'
import { BaseScopedUsersStore, UserDirectoryKind, UserStoreEventBus } from '@ti/shared/user/stores'

@Injectable({ providedIn: 'root' })
export class TiAdminUsersStore extends BaseScopedUsersStore<UserProfile> {
  protected readonly api = inject(ApiService)
  protected readonly events = inject(UserStoreEventBus)
  protected readonly realtimeClient = inject(RealtimeClient)

  public constructor() {
    super()
    this.events.connectRealtime(this.realtimeClient)
    this.connectEvents(this.events, UserDirectoryKind.TiAdmin, () => ({ scope: undefined }))
  }

  protected scopeKey(): string {
    return 'ti-admin'
  }

  protected loadPage(_scope: void, page: number, pageSize: number): Promise<UserProfile[]> {
    return this.api.ti.user.listAdmin({ page, pageSize, order: 'ASC', orderBy: 'id' })
  }

  protected loadByIds(_scope: void, ids: string[]): Promise<UserProfile[]> {
    return this.api.ti.user.listAdmin({ page: 0, pageSize: ids.length, filter: { id: ids } })
  }

  protected loadSnapshot(): Promise<UserSnapshot[]> {
    return this.api.ti.user.snapshotAdmin()
  }
}

@Injectable({ providedIn: 'root' })
export class TiTspUsersStore extends BaseScopedUsersStore<UserProfileTiView> {
  protected readonly api = inject(ApiService)
  protected readonly events = inject(UserStoreEventBus)
  protected readonly realtimeClient = inject(RealtimeClient)

  public constructor() {
    super()
    this.events.connectRealtime(this.realtimeClient)
    this.connectEvents(this.events, UserDirectoryKind.TiTsp, () => ({ scope: undefined }))
  }

  protected scopeKey(): string {
    return 'ti-tsp'
  }

  protected loadPage(_scope: void, page: number, pageSize: number): Promise<UserProfileTiView[]> {
    return this.api.ti.user.listTsp({ page, pageSize, order: 'ASC', orderBy: 'id' })
  }

  protected loadByIds(_scope: void, ids: string[]): Promise<UserProfileTiView[]> {
    return this.api.ti.user.listTsp({ page: 0, pageSize: ids.length, filter: { id: ids } })
  }

  protected loadSnapshot(): Promise<UserSnapshot[]> {
    return this.api.ti.user.snapshotTsp()
  }
}
